import { NextRequest, NextResponse } from 'next/server';
import { db, pool } from '@/lib/db';

export async function PUT(request: NextRequest) {
  try {
    const body = await request.json();
    const {
      email,
      profilePhoto,
      firstName,
      lastName,
      phone,
      location,
      bio,
      yearsOfExperience,
      specializations,
      servicesOffered,
      sessionPricing,
      availability,
      preferredEnvironment,
      travelDistance,
      additionalNotes,
    } = body;

    if (!email) {
      return NextResponse.json(
        { error: 'Email is required' },
        { status: 400 }
      );
    }

    // Find trainer by email
    const trainers = await db.trainers.findByOwnerEmail(email);
    
    if (trainers.length === 0) {
      return NextResponse.json(
        { error: 'Trainer profile not found' },
        { status: 404 }
      );
    }

    const trainerId = trainers[0].id;

    // Update trainer profile
    await pool.execute(
      `UPDATE trainers SET 
        profile_photo = ?,
        first_name = ?,
        last_name = ?,
        phone = ?,
        location = ?,
        bio = ?,
        years_of_experience = ?,
        specializations = ?,
        services_offered = ?,
        session_pricing = ?,
        availability = ?,
        preferred_environment = ?,
        travel_distance = ?,
        additional_notes = ?
      WHERE id = ?`,
      [
        profilePhoto || null,
        firstName,
        lastName,
        phone,
        location,
        bio,
        yearsOfExperience,
        JSON.stringify(specializations),
        JSON.stringify(servicesOffered),
        sessionPricing || null,
        availability ? JSON.stringify(availability) : null,
        JSON.stringify(preferredEnvironment),
        travelDistance || null,
        additionalNotes || null,
        trainerId
      ]
    );

    // Fetch updated trainer
    const updatedTrainer = await db.trainers.findById(trainerId);

    return NextResponse.json({
      success: true,
      message: 'Trainer profile updated successfully',
      trainer: updatedTrainer,
    });
  } catch (error) {
    console.error('Error updating trainer profile:', error);
    return NextResponse.json(
      { error: 'Failed to update trainer profile' },
      { status: 500 }
    );
  }
}
